import { ORGAN_ICONS } from "@/lib/organs";

export function OrganIcon({ icon, size = 22 }) {
  const Icon = ORGAN_ICONS[icon] || ORGAN_ICONS.Brain;
  return <Icon size={size} />;
}

export function SectionTitle({ children }) {
  return <h3 className="text-xs tracking-[0.22em] text-gray-500 font-semibold mb-3 uppercase">{children}</h3>;
}

export function DemoBanner() {
  return (
    <div data-testid="demo-banner" className="chip !text-amber-300/80 !border-amber-400/20 !bg-amber-400/5">
      Dati dimostrativi
    </div>
  );
}
